<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { Content } from '@shared/ui/content';
  import { HoverLink } from '@shared/ui/links/hover-link';
  import { timeToRead } from '@shared/utils';
  import { DateFormatter } from '@shared/utils/date';

  import { ArticleInfo } from '@entities/news';
  import type { NewsFromManyResponse } from '@entities/news/types';

  export let article: NewsFromManyResponse['data'][number];

  const dateFormatter = new DateFormatter();
  const publicationDate = dateFormatter.formatLong(article?.custom_publication_date);

  $: readTime = timeToRead(article.content?.blocks);
</script>

<li class="mb-12 last:mb-0 md:py-12 xl:py-12">
  <article class="block md:grid md:grid-cols-12 md:gap-8 xl:gap-12">
    <div class="mb-5 flex flex-col gap-4 md:col-span-8 md:mb-0 xl:col-span-7 xl:h-full xl:justify-between">
      <div>
        <h3 class="order-1 mb-2.5 text-2xl font-medium md:mb-3 md:text-3xl xl:text-5xl">
          <a
            href="/article-{article.slug}/"
            class="hover:decoration-default-900 hover:dark:decoration-dark-900 dark:decoration-dark-500 decoration-default-350 underline decoration-[1px] underline-offset-8 transition-colors"
          >
            {article.header}
          </a>
        </h3>

        <ArticleInfo {publicationDate} {readTime} author="{article.author}" />

        <a
          href="/article-{article.slug}/"
          class="mb-5 block w-full overflow-hidden rounded-lg md:col-span-4 md:col-start-9 md:mx-auto md:mb-0 md:hidden md:max-w-[212px] md:self-start xl:order-3 xl:max-w-[400px]"
        >
          <DirectusImage
            imageData="{article.cover}"
            pictureSizes="{{
              default: '100vw',
              'min-768': '33vw',
              'min-1024': 'calc((100vw - 200px) / 3)',
              'min-1280': 'calc((100vw - 200px) / 4)',
              'min-1536': 'calc((100vw - 200px) / 5)',
            }}"
            presetKeys="{Preset.Thumbnail}"
            alt="{article.header}"
            imgClasses="w-full h-full object-cover w-full transition-transform duration-300 hover:scale-105"
            loading="lazy"
          />
        </a>

        <p class="md:mb-6 xl:order-4">
          <Content blocks="{article.short_description.blocks}" />
        </p>
      </div>

      <HoverLink link="article-{article.slug}/" classes="text-sm xl:order-5 inline-flex">Read More</HoverLink>
    </div>

    <a
      href="/article-{article.slug}/"
      class="hidden h-max w-full overflow-hidden rounded-lg md:col-span-4 md:col-start-9 md:mx-auto md:mb-0 md:block md:max-w-[212px] xl:max-w-[400px]"
    >
      <DirectusImage
        imageData="{article.cover}"
        pictureSizes="{{
          default: '100vw',
          'min-768': '33vw',
        }}"
        presetKeys="{Preset.Thumbnail}"
        alt="{article.header}"
        imgClasses="w-full h-full object-contain w-full transition-transform h-auto duration-300 hover:scale-105"
        loading="lazy"
      />
    </a>
  </article>
</li>
